import { useState } from 'react';
import { useAlerts } from '@/hooks/use-alerts';
import clsx from 'clsx';

export const Alerts = () => {
    const { getActiveAlerts, setAlertDismissed } = useAlerts();
    const [isDismissed, setIsDismissed] = useState<null | boolean>(null);
    const [pauseAnimation, setPauseAnimation] = useState(false);

    if (!getActiveAlerts().length) {
        return null;
    }

    const dismissAlerts = () => {
        setIsDismissed(true);
        getActiveAlerts().forEach(({ id }) => setAlertDismissed(id));
    };

    return (
        <div
            onMouseEnter={() => setPauseAnimation(true)}
            onMouseLeave={() => setPauseAnimation(false)}
            className={clsx('scrollbar-hide r-relative r-w-full r-overflow-hidden r-bg-secondary-400 r-px-2 r-py-6 r-text-white md:r-px-4', {
                'r-hidden': isDismissed === true,
            })}
        >
            <button className="r-absolute -r-top-1 r-right-1 r-text-3xl md:-r-top-2" onClick={dismissAlerts} role="button">
                &times;
            </button>
            <div
                style={{ animationPlayState: pauseAnimation ? 'paused' : 'running' }}
                className="r-flex r-gap-8 md:r-animate-[ticker_20s_linear_infinite] md:r-whitespace-nowrap md:r-px-2 xl:r-animate-[ticker_25s_linear_infinite]"
            >
                {getActiveAlerts().map(({ id, message, bold_start_of_message: boldStart }) => (
                    <div key={id} className="md:r-flex md:r-gap-2">
                        <div className="r-font-bold max-md:r-pb-2" dangerouslySetInnerHTML={{ __html: boldStart }} />
                        <div dangerouslySetInnerHTML={{ __html: message.replace(/<br\s?\/?>/g, ' ') }} />
                    </div>
                ))}
            </div>
        </div>
    );
};
